const getUserEmailByCode = (users, code) => { var _a; return ((_a = users.find(c => c.code === code)) === null || _a === void 0 ? void 0 : _a.email) || code; };
export default getUserEmailByCode;
